import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { X } from 'lucide-react';
export function WhyFailSection() {
  const failures = ['"Ponele más onda"', '"Sorprendelo/a con algo"', '"Tienen que hablar más"', '"Dense un tiempo"'];
  return <Section background="primary" className="text-center" data-id="element-205">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-206">
        <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-207">
          Los consejos genéricos no salvan relaciones
        </h2>
        <p className="text-muted mb-12 max-w-2xl mx-auto" data-id="element-208">
          Seguramente ya intentaron todo lo que les dijeron sus amigos o leyeron
          en internet.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto mb-16" data-id="element-209">
          {failures.map((item, index) => <div key={index} className="bg-navy-800 p-6 rounded-xl border border-navy-border flex flex-col items-center justify-center h-32 relative overflow-hidden group" data-id="element-210">
              <div className="absolute inset-0 bg-red-500/5 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-211" />
              <span className="text-lg text-muted font-medium italic" data-id="element-212">
                {item}
              </span>
              <X className="text-red-400/50 mt-3 w-6 h-6" data-id="element-213" />
            </div>)}
        </div>

        <div className="bg-navy-800 border border-accent/20 p-8 rounded-2xl max-w-3xl mx-auto relative overflow-hidden" data-id="element-214">
          <div className="absolute top-0 left-0 w-1 h-full bg-accent" data-id="element-215" />
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed text-left" data-id="element-216">
            El verdadero problema no es la falta de amor. El problema es que{' '}
            <span className="text-accent font-bold" data-id="element-217">
              no tienen un mapa claro
            </span>{' '}
            para transformar su dinámica. Nadie nos enseña a amar de forma
            consciente, a pelear de forma sana, ni a reconstruir la confianza.
          </p>
        </div>
      </motion.div>
    </Section>;
}